<template>
  <div class="about">
    <h1>{{ $t('about.example') }}</h1>
  </div>
</template>
